import styled from 'styled-components';
import {GlobalColors, GlobalFonts} from '../../globals';

export const ContMarketPlaceSummary = styled.div`
  position: relative;
  z-index: 1;
  
  @media(min-width: 300px) and (max-width: 767px){
    margin-top: 30px !important;
  }
  @media(min-width: 768px) and (max-width: 1023px){
    margin-top: 30px !important;
  }
  @media(min-width: 1024px) and (max-width: 1079px){
    margin-top: 30px !important;
  }
  @media(min-width: 1080px) and (max-width: 1279px){
    margin-top: 30px !important;
  }
  @media(min-width: 1280px) and (max-width: 1407px){
    margin-top: 30px !important;
  }
  @media(min-width: 1408px) and (max-width: 1439px){
    margin-top: 30px !important;
  }
  @media(min-width: 1440px) and (max-width: 1919px){
    margin-top: 30px !important;
  }
  @media(min-width: 1920px){
    margin-top: 50px !important;
  }
`
export const ContSlidersMarketPlaceSummary = styled.div`
  width: 95%;
  
  @media(min-width: 300px) and (max-width: 1023px){
    width: 100%;
  }
`
export const TitleMarketPlaceSummary = styled.div`
  margin-bottom: 20px;
  font-family: ${GlobalFonts.fontBold};
  text-align: left;
  color: ${GlobalColors.colorSecondary};
  
  @media(min-width: 300px) and (max-width: 767px){
    font-size: 30px;
    line-height: 38px;
    text-align: left;
  }
  @media(min-width: 768px) and (max-width: 1023px){
    position: relative;
    width: 70%;
    margin: 0 auto 35px;
    font-size: 40px;
    line-height: 50px;
    text-align: center;
  }
  @media(min-width: 1024px) and (max-width: 1079px){
    font-size: 36px;
    line-height: 36px;
  }
  @media(min-width: 1080px) and (max-width: 1279px){
    font-size: 34px;
    line-height: 46px;
  }
  @media(min-width: 1280px) and (max-width: 1407px){
    font-size: 46px;
  }
  @media(min-width: 1408px) and (max-width: 1439px){
    font-size: 46px;
  }
  @media(min-width: 1440px) and (max-width: 1919px){
    font-size: 46px;
    line-height: 36px;
  }
  @media(min-width: 1920px){
    font-size: 46px;
    line-height: 36px;
  }
`
export const TextMarketPlaceSummary = styled.h2`
  margin-bottom: 40px;
  font-family: ${GlobalFonts.fontRegular};
  font-size: 20px;
  line-height: 28px;
  color: ${GlobalColors.colorSecondary};
  
  & > span {
    font-family: ${GlobalFonts.fontBold};
  }

  @media(min-width: 300px) and (max-width: 767px){
    margin-bottom: 40px;
    font-size: 20px;
    line-height: 28px;
    text-align: left;
  }
  @media(min-width: 768px) and (max-width: 1023px){
    position: relative;
    width: 80%;
    margin: 0 auto 35px;
    font-size: 20px;
    line-height: 28px;
    text-align: center;
  }
  @media(min-width: 1024px) and (max-width: 1079px){
    font-size: 20px;
    line-height: 28px;
  }
  @media(min-width: 1080px) and (max-width: 1279px){
    font-size: 20px;
    line-height: 28px;
  }
`
export const ContButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;

  @media(min-width: 300px) and (max-width: 767px){
    margin-bottom: 30px;
    justify-content: start;
  }
  @media(min-width: 768px) and (max-width: 1023px){
    margin-bottom: 35px;
    justify-content: center;
  }
`
